"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChatStageType = exports.ChatStatusType = exports.MessageStatusType = exports.MessageAuthorType = void 0;
/**
 * Pertains to the `type` of a message, used to
 * distinguish messages from one another.
 */
var MessageAuthorType;
(function (MessageAuthorType) {
  MessageAuthorType["Bot"] = "bot";
  MessageAuthorType["User"] = "customer";
  MessageAuthorType["Agent"] = "liveAgent";
  MessageAuthorType["System"] = "system";
  MessageAuthorType["SystemHidden"] = "systemHidden";
})(MessageAuthorType || (exports.MessageAuthorType = MessageAuthorType = {}));
/**
 * Pertains to the lifecycle of a client message
 * being sent to the API, facilitating unique UI
 * for each of these lifecycle stages, per-message.
 */
var MessageStatusType;
(function (MessageStatusType) {
  MessageStatusType["Idle"] = "Idle";
  MessageStatusType["Sending"] = "Sending";
  MessageStatusType["Received"] = "Received";
  MessageStatusType["Error"] = "Error";
})(MessageStatusType || (exports.MessageStatusType = MessageStatusType = {}));
/**
 * Pertains to the local/client chat status,
 * corresponding to the below `ChatStageType`
 * received from the API. This is a separate type
 * as it is flexible/customizable for UI purposes.
 */
var ChatStatusType;
(function (ChatStatusType) {
  ChatStatusType[ChatStatusType["NotStarted"] = 0] = "NotStarted";
  ChatStatusType[ChatStatusType["TalkingToBot"] = 1] = "TalkingToBot";
  ChatStatusType[ChatStatusType["Transferring"] = 2] = "Transferring";
  ChatStatusType[ChatStatusType["TalkingToAgent"] = 3] = "TalkingToAgent";
  ChatStatusType[ChatStatusType["Ended"] = 4] = "Ended";
  ChatStatusType[ChatStatusType["Expired"] = 5] = "Expired";
})(ChatStatusType || (exports.ChatStatusType = ChatStatusType = {}));
/**
 * Pertains to the stage/status of the chat session
 * as dictated by the API. Informs us (the client)
 * of the current context of the chat session.
 */
var ChatStageType;
(function (ChatStageType) {
  ChatStageType["Bot"] = "bot";
  ChatStageType["Waiting"] = "waiting";
  ChatStageType["LiveAgent"] = "liveAgent";
  ChatStageType["Ended"] = "ended";
})(ChatStageType || (exports.ChatStageType = ChatStageType = {}));